export const validation = {
  titleMaxChar: 100,
  paragraphMaxChar: 300,
  title: { required: true }
}